/* ========== Spotlight cart.js core (unchanged behavior) ========== */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    const debouncedOnChange = debounce((event) => { this.onChange(event); }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      return this.onCartUpdate();
    });
  }
  disconnectedCallback() { if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber(); }
  resetQuantityInput(id) { const input = this.querySelector(`#Quantity-${id}`); input.value = input.getAttribute('value'); this.isEnterPressed = false; }
  setValidity(event, index, message) { event.target.setCustomValidity(message); event.target.reportValidity(); this.resetQuantityInput(index); event.target.select(); }
  validateQuantity(event) {
    const inputValue = parseInt(event.target.value); const index = event.target.dataset.index; let message = '';
    if (inputValue < event.target.dataset.min) message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    else if (inputValue > parseInt(event.target.max)) message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    else if (inputValue % parseInt(event.target.step) !== 0) message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    if (message) { this.setValidity(event, index, message); }
    else {
      event.target.setCustomValidity(''); event.target.reportValidity();
      this.updateQuantity(index, inputValue, event, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
    }
  }
  onChange(event) { this.validateQuantity(event); }
  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`).then((r)=>r.text()).then((t)=>{
        const html = new DOMParser().parseFromString(t, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel)=>{
          const target = document.querySelector(sel); const source = html.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });
      }).catch(console.error);
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`).then((r)=>r.text()).then((t)=>{
        const html = new DOMParser().parseFromString(t, 'text/html');
        const sourceQty = html.querySelector('cart-items'); this.innerHTML = sourceQty.innerHTML;
      }).catch(console.error);
    }
  }
  getSectionsToRender() {
    return [
      { id: 'main-cart-items', section: document.getElementById('main-cart-items').dataset.id, selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'main-cart-footer', section: document.getElementById('main-cart-footer').dataset.id, selector: '.js-contents' },
    ];
  }
  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({ line, quantity, sections: this.getSectionsToRender().map((s)=>s.section), sections_url: window.location.pathname });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((r)=>r.text()).then((state)=>{
        const parsedState = JSON.parse(state);
        CartPerformance.measure(`${eventTarget}:paint-updated-sections"`, () => {
          const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
          const items = document.querySelectorAll('.cart-item');
          if (parsedState.errors) { quantityElement.value = quantityElement.getAttribute('value'); this.updateLiveRegions(line, parsedState.errors); return; }
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer'); const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            message = (typeof updatedValue === 'undefined') ? window.cartStrings.error : window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
          this.updateLiveRegions(line, message);
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        });
        CartPerformance.measureFromEvent(`${eventTarget}:user-action`, event);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((o) => o.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => { this.disableLoading(line); });
  }
  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
    setTimeout(() => { cartStatus.setAttribute('aria-hidden', true); }, 1000);
  }
  getSectionInnerHTML(html, selector) { return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML; }
  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    [...cartItemElements, ...cartDrawerItemElements].forEach((o) => o.classList.remove('hidden'));
    document.activeElement.blur(); this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }
  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);
    cartItemElements.forEach((o) => o.classList.add('hidden')); cartDrawerItemElements.forEach((o) => o.classList.add('hidden'));
  }
}
customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then(() => CartPerformance.measureFromEvent('note-update:user-action', event));
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}

/* ===== CM: Savings engine – fills [data-cm-saving], keeps totals correct ===== */
(function(){
  if (window.__cmSavingsFixInstalled) return;
  window.__cmSavingsFixInstalled = true;

  function moneyFormatter(){
    if (window.Shopify && typeof Shopify.formatMoney === 'function'){
      var fmt = Shopify.money_with_currency_format || Shopify.money_format || (window.theme && theme.moneyFormat) || '{{amount}}';
      return function(cents){ return Shopify.formatMoney(cents, fmt); };
    }
    var currency = (Shopify && Shopify.currency && Shopify.currency.active) ||
                   (window.localization && window.localization.country && window.localization.country.currency && window.localization.country.currency.iso_code) ||
                   'USD';
    return function(cents){
      try { return new Intl.NumberFormat(undefined, {style:'currency', currency}).format(cents/100); }
      catch(e){ return (cents/100).toFixed(2); }
    };
  }
  var formatMoney = moneyFormatter();

  function computeTotals(cart){
    var original = 0, bundleSavings = 0;
    cart.items.forEach(function(item){
      var qty = item.quantity || 1;
      var base = item.original_line_price;
      var wasEach = 0, pct = 0;
      if (item.properties){
        if (item.properties._cm_was_cents) wasEach = Number(item.properties._cm_was_cents) || 0;
        if (item.properties._cm_pct)       pct      = Number(item.properties._cm_pct) || 0;
      }
      if (wasEach > 0){
        base = wasEach * qty;
        if (pct > 0) bundleSavings += Math.round(wasEach * pct / 100) * qty;
      }
      if (!base || base < item.line_price) base = item.line_price;
      original += base;
    });
    var savings = (cart.total_discount && cart.total_discount > 0) ? cart.total_discount : bundleSavings;
    if (!savings || savings < 0) savings = Math.max(0, original - cart.total_price);
    return { original: original, savings: savings, total: cart.total_price };
  }

  var writing = false, inFlight = false, pending = false, backoffMs = 0, timer = null;

  function apply(container, data){
    if (!container) return;
    // Estimated total text
    var totalEl = container.querySelector('.totals__total-value');
    if (totalEl) totalEl.textContent = formatMoney(data.total);

    // Any native savings placeholders
    container.querySelectorAll('[data-cm-saving]').forEach(function(el){
      el.textContent = formatMoney(data.savings);
    });
  }

  function applyAll(data){
    writing = true;
    try {
      apply(document.getElementById('main-cart-footer'), data);
      apply(document.querySelector('.cart-drawer__footer') || document.querySelector('.drawer__footer'), data);
    } finally { setTimeout(function(){ writing = false; }, 0); }
  }

  function refresh(){
    if (inFlight) { pending = true; return; }
    inFlight = true;
    setTimeout(function(){
      fetch('/cart.js', { credentials:'same-origin', cache:'no-store' })
        .then(function(r){ if (r.status===429) throw { _429:true }; return r.json(); })
        .then(function(cart){ backoffMs = 0; applyAll(computeTotals(cart)); })
        .catch(function(err){ if (err && err._429) backoffMs = Math.min(2000, (backoffMs||250)*2); })
        .finally(function(){ inFlight=false; if (pending) { pending=false; schedule(); } });
    }, backoffMs);
  }

  function schedule(){ if (timer) return; timer = setTimeout(function(){ timer=null; refresh(); }, 120); }

  function boot(){
    schedule();
    document.addEventListener('cart:refresh', schedule, { passive:true });
    window.addEventListener('shopify:currency:change', schedule, { passive:true });

    var obs = new MutationObserver(function(){ if (!writing) schedule(); });
    ['#main-cart-footer', '.cart-drawer__footer', '.drawer__footer'].forEach(function(sel){
      var n = document.querySelector(sel); if (n) try { obs.observe(n, {childList:true, subtree:true}); } catch(e){}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
})();
